import { Grid, Typography } from '@mui/material';
import ActionButton from 'components/buttons';
import DialogModal from 'components/modal/dialog-modal';
import { FC } from 'react';

interface DeletePostMediaConfirmModalProps {
  open: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onDeletePostOnly: () => void;
  onDeleteAll: () => void;
}

export const DeletePostMediaConfirmModal: FC<DeletePostMediaConfirmModalProps> = ({
  open,
  isLoading,
  onClose,
  onDeletePostOnly,
  onDeleteAll,
}) => {
  return (
    <DialogModal open={open} maxWidth="570px" withCloseButton={false} handleClose={onClose}>
      <Grid container sx={{ mb: '10px' }} alignItems="center">
        <Typography
          sx={{
            fontSize: '24px',
            lineHeight: '28px',
            fontWeight: 400,
            color: '#23252F',
            fontFamily: 'Inter, sans-serif !important',
          }}
        >
          There is media associated to this post - delete?
        </Typography>
      </Grid>

      <Grid container justifyContent="flex-end" sx={{ mt: '20px' }} gap={2}>
        <ActionButton variant="secondary" onClick={onClose} disabled={isLoading} label="Cancel" />
        <ActionButton
          variant="secondary"
          onClick={onDeletePostOnly}
          loading={isLoading}
          label="Delete post only"
        />
        <ActionButton
          onClick={onDeleteAll}
          loading={isLoading}
          label="Delete All"
          style={{ backgroundColor: '#D12D36' }}
        />
      </Grid>
    </DialogModal>
  );
};
